import React from 'react';
import { Translation } from 'react-i18next';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.error(error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Translation>
          {
            (t, { i18n }) =>  <p>{t("errors.somethingWrong")}</p>
          }
        </Translation>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
